// Application Configuration
// Change these values to rebrand the application

export const APP_CONFIG = {
  // Application Name (configurable via VITE_APP_NAME env var)
  appName: import.meta.env.VITE_APP_NAME || 'PM-One HRMS',
  
  // Application Details
  appTagline: 'Human Resource Management System',
  companyName: 'PM-One',
  
  // Contact Information
  supportEmail: 'HumanRelations@parallel-minds.com',
  contactEmail: 'HumanRelations@parallel-minds.com',
  
  // Storage keys.
  //
  // Everything below is SESSION state and lives in sessionStorage, so it dies
  // with the browser tab: closing it ends the session and the next visit has to
  // sign in again. Nothing that identifies a user may be written to
  // localStorage, which survives a closed browser and is shared across tabs.
  //
  // Device preferences are the exception and stay in localStorage on purpose —
  // they say nothing about who is signed in and should outlive a session:
  //   hrms-theme            light/dark choice for this browser
  //   user_timezone         detected timezone, re-detected if missing
  //   hrms_push_*           Web Push flags, tied to a per-origin browser grant
  storageKeys: {
    attendance: 'pm_people_attendance',
    user: 'hrms-user',
    token: 'hrms-token',
    probationNoticeShown: 'probation_notice_shown',
  },
  
  // Feature Flags
  features: {
    multiIntervalAttendance: true,
    geolocation: true,
    officeDetection: true,
  },
} as const;

// Export individual values for convenience
export const APP_NAME = APP_CONFIG.appName;
export const SUPPORT_EMAIL = APP_CONFIG.supportEmail;
export const STORAGE_KEYS = APP_CONFIG.storageKeys;
